module.exports = __webpack_public_path__ + "static/media/stimulate-scan.37f7f782.png";